import { createFileRoute } from '@tanstack/react-router';
import { getNotesOptions } from '../../../../features/customer/notes/queryOptions';
import { validateSearch } from '../../../../utils/pagination';
import { NoteTable } from './../../../../features/shared/note/note-table';
import { useFilter } from './../../../../utils/filter/filter';
import { useQuery } from '@tanstack/react-query';

export const Route = createFileRoute(
  '/_authenticated/customers/$guid/_layout/notes',
)({
  component: Page,
  loaderDeps: ({ search: { page } }) => ({ page }),
  loader: ({ context: { queryClient }, deps: { page }, params: { guid } }) =>
    queryClient.ensureQueryData(getNotesOptions(guid, { page })),
  validateSearch: validateSearch,
});

function Page() {
  const { guid } = Route.useParams();
  const {
    state,
    dispatch: setSearch,
    mappedState,
  } = useFilter('/customers/$guid/notes');

  const { data } = useQuery(
    getNotesOptions(guid, mappedState, Route.useLoaderData()),
  );

  return (
    <div className="col-span-full flex items-center justify-between">
      <NoteTable
        response={data?.response}
        pagination={data?.pagination}
        state={state}
        setSearch={setSearch}
      />
    </div>
  );
}
